// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.flask_type_enum_ee622886 */
var FlaskTypeEnumEe622886;
(function (FlaskTypeEnumEe622886) {
    FlaskTypeEnumEe622886["2L Baffled"] = "2L Baffled";
})(FlaskTypeEnumEe622886 || (FlaskTypeEnumEe622886 = {}));
;
export default FlaskTypeEnumEe622886;
/** Zod schema for flask_type_enum_ee622886 */
export const flaskTypeEnumEe622886 = z.nativeEnum(FlaskTypeEnumEe622886);
//# sourceMappingURL=FlaskTypeEnumEe622886.js.map